import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useGallery } from '../context/GalleryContext';
import { firstLeafPath } from '../util/galleryResolver';
import { GallerySectionPage } from './GallerySectionPage';
import { ViewingRoomPage } from './ViewingRoomPage';
import { NotFoundPage } from './NotFoundPage';

// Resolves an arbitrary-depth gallery path (architecture §3):
//  - a branch section       → redirect to its first gallery leaf
//  - a gallery-leaf section  → GallerySectionPage
//  - <sectionPath>/<slug>    → ViewingRoomPage (slug is an artwork in that section)
//  - anything else           → 404
export const GalleryRouter = () => {
    const { pathname } = useLocation();
    const { getSection, getMembership, getArtwork } = useGallery();
    const slugPath = pathname.split('/').filter(Boolean);

    const section = getSection(slugPath);
    if (section) {
        if (section.href) return <Navigate to={section.href} replace />;
        if (section.children && section.children.length) {
            const leaf = firstLeafPath(section, slugPath);
            return leaf ? <Navigate to={`/${leaf.join('/')}`} replace /> : <NotFoundPage />;
        }
        return <GallerySectionPage slugPath={slugPath} />;
    }

    if (slugPath.length >= 2) {
        const sectionPath = slugPath.slice(0, -1);
        const artworkSlug = slugPath[slugPath.length - 1];
        const parent = getSection(sectionPath);
        const isGalleryLeaf = parent && !(parent.children && parent.children.length) && !parent.href;
        if (isGalleryLeaf && getMembership(sectionPath).some((a) => a.slug === artworkSlug) && getArtwork(artworkSlug)) {
            return <ViewingRoomPage sectionPath={sectionPath} artworkSlug={artworkSlug} />;
        }
    }

    return <NotFoundPage />;
};
